module.exports = __webpack_public_path__ + "img/frame-browser-foujita-en.ec22ca22.jpg";